import * as signalR from "@microsoft/signalr";

let connection;

const getConnection = () => {
    if (!connection) {
        const saved = localStorage.getItem("user");
        if (saved) {
            try {
                var userId = JSON.parse(saved).id;
            } catch (e) {
                return null;
            }
        } else {
            return null;
        }
        connection = new signalR.HubConnectionBuilder()
            .withUrl("/chat", {
                headers: {"X-User": userId},
                accessTokenFactory: () => userId,
            })
            .withAutomaticReconnect()
            .build();
    }
    return connection;
}

export default getConnection;
